var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-chip',{staticClass:"kit-status-chip",attrs:{"x-small":"","color":_vm.color,"text-color":"accent"}},[_vm._v("\n  "+_vm._s(_vm.label)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }